<template>
  <router-view></router-view>
</template>

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import Cookies from "js-cookie";

const store = useStore();

onMounted(() => {
  const user = Cookies.get("user");

  if (user) {
    try {
      const acc = JSON.parse(user);
      console.log("userAPP", acc);
      store.commit("setUser", acc);
    } catch (error) {
      console.error("Ошибка парсинга user из cookies:", error);
    }
  }

  const frontendLocaltime = Date.now();

  setTimeout(() => {
    const frontendMsecOnPage = Date.now() - frontendLocaltime;
    Cookies.set("time_onpage", frontendMsecOnPage);
  }, 100);
});
</script>
